import { render, staticRenderFns } from "./CarouselControls.vue?vue&type=template&id=543f1cee&"
import script from "./CarouselControls.vue?vue&type=script&lang=js&"
export * from "./CarouselControls.vue?vue&type=script&lang=js&"
import style0 from "./CarouselControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports